<ub-heading i18n>Emails</ub-heading>
<div>
  <h4>Primary Email Address</h4>
  <div>{{primaryEmail}}</div>
</div>
<div *ngFor="let secondaryEmail of secondaryEmails">
  <h4>Secondary Email Address</h4>
  <div>{{secondaryEmail}}</div>
</div>
